import { createGlobalStyle } from 'styled-components'

const DisableScrollAnchoring = createGlobalStyle`
  body {
    overflow-anchor: none;
  }
`

export default DisableScrollAnchoring
